import styled from "styled-components";

export const TopBarContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;

export const ButtonGroup = styled.div`
  display: flex;
`;

export const ContainerFooterBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const ModalButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 246px;
  height: 44px;
  padding: 14px 32px;

  color: ${(props) => props.theme.colors.body};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.75;

  cursor: pointer;

  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 40px;
  background-color: ${(props) => props.theme.colors.white};

  &.red-btn {
    color: ${(props) => props.theme.colors.background};

    border: none;
    background-color: ${(props) => props.theme.colors.primary};
  }

  &:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: 771px) {
  }
`;
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
